import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function CarEngineRepairMoney({
  className,
  fillPrimary = colors.neutral100,
  fillSecondary = colors.aqua50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="car-repair-engine 1" clipPath="url(#clip0_3973_2881)">
        <path
          id="Vector"
          d="M18 47C20.7614 47 23 46.9853 23 44.5C23 42.0147 20.7614 40 18 40C15.2386 40 13 42.0147 13 44.5C13 46.9853 15.2386 47 18 47Z"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M12 44H-5"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M-6.02623 42.1686L-9.2778 41.9079C-10.0709 41.8444 -10.8063 41.4683 -11.3221 40.8625C-11.8379 40.2568 -12.092 39.4709 -12.0284 38.6778L-11.7887 35.6874C-11.6615 34.1012 -10.9094 32.6304 -9.69785 31.5987C-8.4863 30.5671 -6.91454 30.0589 -5.32833 30.1861L-1.08329 23.1609C-0.794991 22.684 -0.379587 22.2969 0.116364 22.0429C0.612315 21.7889 1.16921 21.678 1.72464 21.7227L11.4933 22.5059C12.0487 22.5503 12.5809 22.7485 13.03 23.0783C13.4791 23.4081 13.8276 23.8565 14.0362 24.3731L17.0997 31.9843L27.5661 32.8235C29.1523 32.9507 30.623 33.7028 31.6547 34.9143C32.6864 36.1259 33.1946 37.6976 33.0674 39.2838L32.8276 42.2742C32.764 43.0674 32.388 43.8027 31.7822 44.3186C31.1764 44.8344 30.3906 45.0885 29.5974 45.0249L24.3575 44.5246"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M18 32L-13 31"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="$0">
          <path
            id="Vector_5"
            d="M42.9697 14.1784C40.5355 14.1784 39.179 12.1511 39.179 8.50361C39.179 4.84854 40.5355 2.82129 42.9697 2.82129C45.4039 2.82129 46.7604 4.84854 46.7604 8.50361C46.7604 12.1511 45.4039 14.1784 42.9697 14.1784ZM40.7239 8.50361C40.7239 8.8352 40.7314 9.14419 40.754 9.4381L44.9592 6.12216C44.6201 4.83346 43.9494 4.16274 42.9697 4.16274C41.5001 4.16274 40.7239 5.66245 40.7239 8.50361ZM42.9697 12.8445C44.4317 12.8445 45.2079 11.3372 45.2079 8.50361C45.2079 8.16448 45.2004 7.85549 45.1778 7.55404L40.9801 10.8926C41.3192 12.1738 41.99 12.8445 42.9697 12.8445Z"
            fill={fillSecondary}
          />
          <path
            id="Vector_6"
            d="M29.5781 11.0435H30.9497C31.0628 12.0684 31.8767 12.7693 33.0674 12.9125V9.00116L32.8187 8.94087C30.7764 8.45101 29.8419 7.49391 29.8419 5.9113C29.8419 4.17043 31.1004 2.98725 33.0674 2.83652V2H33.9944V2.83652C35.8407 3.00986 37.0917 4.1629 37.1822 5.84348H35.8257C35.7051 4.88638 35.0193 4.23826 33.9944 4.08754V7.8029L34.3033 7.8858C36.4738 8.41333 37.3706 9.31014 37.3706 10.9455C37.3706 12.7768 36.0668 13.9977 33.9944 14.1635V15H33.0674V14.1635C31.0175 14.0203 29.6836 12.8446 29.5781 11.0435ZM31.2512 5.84348C31.2512 6.71768 31.7712 7.21507 33.0674 7.57681V4.08C31.9445 4.21565 31.2512 4.8713 31.2512 5.84348ZM35.9613 11.0435C35.9613 10.1241 35.381 9.58145 33.9944 9.21971V12.9125C35.1775 12.7693 35.9613 12.0458 35.9613 11.0435Z"
            fill={fillSecondary}
          />
        </g>
        <path
          id="Vector_7"
          d="M26 26C25.6714 25.7187 25.4127 25.3792 25.2407 25.0034C25.0687 24.6275 24.9873 24.2237 25.0016 23.8181C25.0016 22.3639 26.9984 21.6361 26.9984 20.1819C27.0127 19.7763 26.9313 19.3725 26.7593 18.9966C26.5873 18.6208 26.3286 18.2813 26 18"
          stroke={fillPrimary}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_8"
          d="M21 28C20.6714 27.7187 20.4127 27.3792 20.2407 27.0034C20.0687 26.6275 19.9873 26.2237 20.0016 25.8181C20.0016 24.3639 21.9984 23.6361 21.9984 22.1819C22.0127 21.7763 21.9313 21.3725 21.7593 20.9966C21.5873 20.6208 21.3286 20.2813 21 20"
          stroke={fillPrimary}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3973_2881">
          <rect width="48" height="48" fill={fillPrimary} />
        </clipPath>
      </defs>
    </svg>
  );
}
